import { FunctionComponent, memo } from 'react';

import { Typography } from '@mui/material';

import { CustomEpgSearch } from '../EPGDataGrid/CustomEpgSearch';
import { GenericObject } from '../common/Table/DefaultTable/types';
import { ListSearch } from './ListSearch';
import './styles.css';

interface ListHeaderProps {
  generalFilterLabel?: string;
  generalFilterKey?: string;
  hideSearch?: boolean;
  title: string;
  showEpgSearch?: boolean;
  SearchFields?: FunctionComponent;
  handleChangeFilters?(filters: GenericObject): void;
}

export const ListHeader = memo(
  ({
    title,
    SearchFields,
    generalFilterLabel,
    generalFilterKey,
    handleChangeFilters,
    hideSearch = false,
    showEpgSearch,
  }: ListHeaderProps) => {
    return (
      <div className={`list-header ${hideSearch && !showEpgSearch ? 'nosearch' : ''}`}>
        <Typography data-cy={title} variant="h3" sx={{ flex: 1, marginLeft: '8px' }}>
          {title}
        </Typography>
        {!hideSearch && (
          <div style={{ display: 'flex', alignItems: 'center', marginTop: 20 }}>
            <ListSearch
              generalFilterLabel={generalFilterLabel}
              SearchFields={SearchFields}
              generalFilterKey={generalFilterKey}
              handleChangeFilters={handleChangeFilters}
            />
          </div>
        )}
        {showEpgSearch && <CustomEpgSearch handleChangeFilters={handleChangeFilters} />}
      </div>
    );
  }
);
